import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskCreated_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';
import { isAutomateTask } from 'src/entities/QuickTask/Utils';
import TaskName from 'src/entities/common/TaskName';

interface Fragments {
  activityLog: ActivityLogTaskCreated_ActivityLogFragment;
}

const ActivityLogTaskCreated: FCWithFragments<Fragments> = ({ activityLog }) => {
  const { details } = activityLog;

  // eslint-disable-next-line no-underscore-dangle
  if (!details || details.__typename !== 'ActivityLogTaskDetails') {
    throw new Error('ActivityLogTaskCreated: details is not ActivityLogTaskDetails');
  }

  const { task, sourcingLinkId } = details;
  const createdViaSourcingLink = !!sourcingLinkId;
  const createdViaAutomation = isAutomateTask(task.creationSource);

  let actionLabelKey = 'hiring-dashboard-candidates:candidates.activityLog.createdTask';
  let actionLabel = `created ${task.name}`;

  if (createdViaSourcingLink && createdViaAutomation) {
    actionLabelKey = 'hiring-dashboard-candidates:candidates.activityLog.createdTaskViaSourcingLinkAndAutomation';
    actionLabel = `created ${task.name} via sourcing link and automation`;
  } else if (createdViaSourcingLink) {
    actionLabelKey = 'hiring-dashboard-candidates:candidates.activityLog.createdTaskViaSourcingLink';
    actionLabel = `created ${task.name} via sourcing link`;
  } else if (createdViaAutomation) {
    actionLabelKey = 'hiring-dashboard-candidates:candidates.activityLog.createdTaskViaAutomation';
    actionLabel = `created ${task.name} via automation`;
  }

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabel={actionLabel}
      actionLabelKey={actionLabelKey}
      actionLabelValues={{ taskName: task.name }}
    />
  );
};

ActivityLogTaskCreated.fragments = {
  activityLog: gql`
    ${TaskName.fragments.task}
    ${ActivityLogBase.fragments.activityLog}

    fragment ActivityLogTaskCreated_activityLog on ActivityLog {
      id
      details {
        ... on ActivityLogTaskDetails {
          __typename
          taskId
          sourcingLinkId
          task {
            id
            creationSource
            ...TaskName_task
          }
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskCreated;
